// User Authenticate and Profile Management

export const ITEMS_HAVE_ERROR = "ITEMS_HAVE_ERROR";
export const ITEMS_HAVE_LOADING = "ITEMS_HAVE_LOADING";
export const ITEMS_HAVE_SUCCESS = "ITEMS_HAVE_SUCCESS";
export const WALLET_CONNECT_SUCCESS = "WALLET_CONNECT_SUCCESS";
export const WALLET_DISCONNECT_SUCCESS = "WALLET_DISCONNECT_SUCCESS";
export const CREATE_COLLECTION_SUCCESS = "CREATE_COLLECTION_SUCCESS";
export const CREATE_FIXED_ITEM_SUCCESS = "CREATE_FIXED_ITEM_SUCCESS";
export const GET_COLLECTIONS_SUCCESS = "GET_COLLECTIONS_SUCCESS";
export const GET_ITDETAILS_SUCCESS = "GET_ITDETAILS_SUCCESS";
export const GET_COLLECTION = "GET_COLLECTION";
export const GET_NFTS = "GET_NFTS";
export const CLEAR_NFTS = "CLEAR_NFTS";
